module.exports = __webpack_public_path__ + "stacked-boxes-2.c33452d18bc08c7d8e8e490d3b99be83.svg";